<template>
  <font-awesome-icon
    icon="check-circle"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faCheckCircle)

export default {
  name: 'CoozzySuccessIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-bg-green-light;
  }
</style>
